import { FC, useEffect } from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import clsx from 'clsx';
import { useAppDispatch, useAppSelector } from 'src/services/redux/app/Store';
import { sellerUrlInFe } from '../../../../helpers/bridgeForFE';
import { checkNewTickets } from '../../../../services/redux/slices/ticket/ticket-slice';
import { KTSVG, toAbsoluteUrl } from '../../../helpers';
import { HeaderUserMenu } from '../../../partials';
import { HeaderChatMenu } from '../../../partials/layout/header-menus/HeaderChatMenu';

const toolbarButtonMarginClass = 'ms-1 ms-lg-3',
  toolbarButtonHeightClass = 'w-30px h-30px w-md-40px h-md-40px',
  toolbarUserAvatarHeightClass = 'symbol-30px symbol-md-30px',
  toolbarButtonIconSizeClass = 'svg-icon-1 text-secondary';

const Topbar: FC = () => {
  const { pathname } = useLocation();
  const { unRead } = useAppSelector((state) => state.announcementList);
  const { data: ticket } = useAppSelector((state) => state.ticketList);
  const { user } = useAppSelector((state) => state.auth);
  const dispatch = useAppDispatch();
  const history = useHistory();
  useEffect(() => {
    dispatch(checkNewTickets());
  }, [history.location]);
  return (
    <div className="d-flex align-items-stretch flex-shrink-0">
      {/* Search */}
      {/* <div className={clsx('d-flex align-items-stretch', toolbarButtonMarginClass)}>
        <Search />
      </div> */}
      {/* FAQ */}
      <div className={clsx('d-flex align-items-center', toolbarButtonMarginClass)}>
        <Link
          className={clsx('fs-5 menu-link py-3 fw-bold text-gray-900', {
            // 'text-primary': checkIsActive(pathname, '/faq'),
            // 'text-gray-900': !checkIsActive(pathname, '/faq'),
          })}
          to={'/faq'}
        >
          <span className="menu-title">Sıkça Sorulan Sorular</span>
        </Link>
      </div>
      {/* FAQ */}
      <div className={clsx('d-flex align-items-center', toolbarButtonMarginClass)} id="kt_chat_menu_toggle">
        {/* begin::Toggle */}
        <div className="position-relative p-1 ">
          {user && (
            <a href={sellerUrlInFe(user.vendor.slug)} target="_blank">
              <KTSVG path="/media/header/shop.svg" className={toolbarButtonIconSizeClass} />
            </a>
          )}
        </div>
      </div>

      <div className={clsx('d-flex align-items-center', toolbarButtonMarginClass)} id="kt_chat_menu_toggle">
        {/* begin::Toggle */}
        <div
          className={clsx('cursor-pointer symbol', toolbarUserAvatarHeightClass)}
          data-kt-menu-trigger="click"
          data-kt-menu-attach="parent"
          data-kt-menu-placement="bottom-end"
          data-kt-menu-flip="bottom"
        >
          <div className="position-relative p-1 ">
            <KTSVG path="/media/icons/duotone/Communication/Group-chat.svg" className={toolbarButtonIconSizeClass} />
            {ticket && ticket.totalCount !== 0 && (
              <div
                className={`position-absolute animation-blink top-0 start-100 translate-middle badge badge-sm rounded-pill bg-danger z-index-1 mb-2 ${
                  ticket.totalCount > 100 ? '' : 'px-1'
                }`}
              >
                {ticket.totalCount}
              </div>
            )}
          </div>
        </div>
        {<HeaderChatMenu ticket={ticket && ticket.ticket} />}
        {/* end::Toggle */}
      </div>

      {/* NOTIFICATIONS */}
      <Link to={'/notifications'} className={clsx('d-flex align-items-center', toolbarButtonMarginClass)}>
        <div
          className={clsx('btn btn-icon btn-active-light-primary', toolbarButtonHeightClass)}
          data-kt-menu-trigger="click"
          data-kt-menu-attach="parent"
          data-kt-menu-placement="bottom-end"
          data-kt-menu-flip="bottom"
        >
          <div className="position-relative p-1 ">
            <KTSVG path="/media/header/bell.svg" className={toolbarButtonIconSizeClass} />
            {unRead !== 0 && unRead && (
              <div className={`position-absolute top-0 start-100 translate-middle badge badge-sm rounded-pill bg-danger z-index-1 mb-2 ${unRead > 100 ? 'px-1' : ''}`}>
                {unRead > 999 ? '999+' : unRead?.toLocaleString()}
              </div>
            )}
          </div>
        </div>
      </Link>
      {/* begin::User */}
      <div className={clsx('d-flex align-items-center', toolbarButtonMarginClass)} id="kt_header_user_menu_toggle">
        {/* begin::Toggle */}
        <div
          className={clsx('cursor-pointer symbol', toolbarUserAvatarHeightClass)}
          data-kt-menu-trigger="click"
          data-kt-menu-attach="parent"
          data-kt-menu-placement="bottom-end"
          data-kt-menu-flip="bottom"
        >
          <img src={toAbsoluteUrl('/media/avatars/blank.png')} alt="avatar" />
        </div>
        {user && (<HeaderUserMenu />)}
        {/* end::Toggle */}
      </div>
      {/* end::User */}

      {/* begin::Aside Toggler */}
    </div>
  );
};

export { Topbar };
